import React from "react";
import styles from "./Switch.module.sass";
const Switch = props => {
  const {
    checked,
    name,
    onChange
  } = props;
  return /*#__PURE__*/React.createElement("label", {
    className: `${styles["container"]} ${checked ? styles["checked"] : ""}`
  }, name ? /*#__PURE__*/React.createElement("small", {
    className: styles["label"]
  }, name) : null, /*#__PURE__*/React.createElement("div", {
    className: styles["switch"],
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onChange && onChange({
        target: {
          value: !checked
        }
      });
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles["tracker"]
  }), /*#__PURE__*/React.createElement("span", {
    className: styles["yes-label"]
  }), /*#__PURE__*/React.createElement("span", {
    className: styles["no-label"]
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles["thumb"]
  })));
};
export default Switch;